<script setup>
// Three rows of the article table with the woot's sample articles, drawn faded behind an empty state (D-G5 keeps
// the faded preview; phase 6.1). Decoration: HelpEmptyState hides it from a screen reader.
import { useI18n } from 'vue-i18n';
import { Badge } from 'dashboard/components-next/polaris/ui/badge';
import articleContent from 'dashboard/components-next/HelpCenter/EmptyState/Portal/portalEmptyStateContent';

const { t } = useI18n();

const STATUS = {
  draft: {
    label: 'HELP_CENTER.ARTICLES_PAGE.ARTICLE_CARD.CARD.STATUS.DRAFT',
    variant: 'warning',
  },
  published: {
    label: 'HELP_CENTER.ARTICLES_PAGE.ARTICLE_CARD.CARD.STATUS.PUBLISHED',
    variant: 'success',
  },
  archived: {
    label: 'HELP_CENTER.ARTICLES_PAGE.ARTICLE_CARD.CARD.STATUS.ARCHIVED',
    variant: 'secondary',
  },
};
const rows = articleContent.slice(0, 3);
</script>

<template>
  <div
    v-for="article in rows"
    :key="article.id"
    class="flex items-center gap-3 px-4 py-3 border border-solid rounded-polaris-md border-polaris-border bg-polaris-card"
  >
    <span class="flex-1 min-w-0 truncate type-polaris-body">
      {{ article.title }}
    </span>
    <span
      class="hidden truncate type-polaris-caption text-polaris-muted-foreground sm:inline"
    >
      {{ `${article.category.icon} ${article.category.name}` }}
    </span>
    <Badge :variant="STATUS[article.status].variant">
      {{ t(STATUS[article.status].label) }}
    </Badge>
  </div>
</template>
